import React, { useState } from "react";
import "./fileChooser.scss";

const FileChooser = ({ errorMessage, onFileChange }) => {
  const [fileName, setFileName] = useState("");

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFileName(file.name);
      onFileChange(file);
    } else {
      setFileName("");
      onFileChange(null);
    }
  };

  return (
    <div
      className="file-chooser-container"
      style={{
        border: errorMessage ? "1px solid  var(--accent-colors-red)" : ""
      }}
    >
      <input
        type="file"
        id="file-input"
        className="file-input"
        onChange={handleFileChange}
      />
      <label htmlFor="file-input" className="file-label">
        {fileName ? fileName : "Choose a file"}
      </label>
      {errorMessage && <p className="errorMessage">{errorMessage}</p>}{" "}
    </div>
  );
};

export default FileChooser;
